import { AsyncPipe, DatePipe, NgIf } from '@angular/common';
import { Component, OnDestroy, ViewChild, inject } from '@angular/core';
import { ResultadoAvaliacao, ResultadoAvaliacaoPaginado } from '../../models/resultado-avaliacao';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';

import { FormAlterarAlcanceComponent } from '../form-alterar-alcance/form-alterar-alcance.component';
import { NenhumResultadoComponent } from '../../../../shared/components/nenhum-resultado/nenhum-resultado.component';
import { ResultadoAvaliacaoInstitucionalService } from '../services/resultado-avaliacao-institucional.service';
import { TableDirective } from '@sigepe/dsgov-theme';
import { filter } from 'rxjs';

@Component({
	selector: 'sgp-resultado-avaliacao-institucional',
	standalone: true,
	imports: [NgIf, DatePipe, AsyncPipe, TableModule, TableDirective, NenhumResultadoComponent, FormAlterarAlcanceComponent],
	templateUrl: './resultado-avaliacao-institucional.component.html'
})
export class ResultadoAvaliacaoInstitucionalComponent implements OnDestroy {
	protected resultadoAvaliacaoService = inject(ResultadoAvaliacaoInstitucionalService);
	exibirModalAlterarAlcance = false;
	@ViewChild('formAlterarAlcance') formAlterarAlcance: FormAlterarAlcanceComponent | undefined;
	@ViewChild('tabelaResultadoAvaliacaoInstitucional', { static: false }) table!: Table;

	ngOnDestroy(): void {
		this.resultadoAvaliacaoService.subscriptions?.unsubscribe();
	}

	alterarAlcance(resultadoAvaliacao: ResultadoAvaliacao) {
		if (resultadoAvaliacao.emAvaliacao) {
			this.exibirModalAlterarAlcance = true;
			const alcance = Number.parseFloat(resultadoAvaliacao.alcance?.replace(',', '.') ?? '0.00');
			this.formAlterarAlcance?.form.patchValue({ alcance: alcance });
			this.formAlterarAlcance?.form.patchValue({ idAvaliacaoInstitucional: resultadoAvaliacao.idAvaliacaoInstitucional });
		}
	}

	atualizarAlcanceNaTabela(alcance: number) {
		this.resultadoAvaliacaoService.resultado$
			?.pipe(filter((resultado): resultado is ResultadoAvaliacaoPaginado => !!resultado))
			.subscribe((resultado: ResultadoAvaliacaoPaginado) => {
				if (resultado.content != undefined && resultado.content?.length > 0) {
					const index = resultado.content.findIndex((r: ResultadoAvaliacao) => {
						return r.idAvaliacaoInstitucional === this.formAlterarAlcance?.form.value.idAvaliacaoInstitucional;
					});
					if (index > -1) {
						resultado.content[index].alcance = alcance.toLocaleString('pt-BR', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});
					}
				}
			});
	}

	lazyLoadging(event: any) {
		this.resultadoAvaliacaoService.filtro.page = event.first / event.rows;
		this.resultadoAvaliacaoService.filtro.size = event.rows;
		this.sort(event);
		this.resultadoAvaliacaoService.pesquisarAlcance();
	}

	sort(event: TableLazyLoadEvent) {
		if (event.sortField != undefined) {
			this.resultadoAvaliacaoService.filtro.sort = typeof event.sortField === 'string' ? event.sortField : event.sortField.join(',');

			if (event.sortOrder === -1) {
				this.resultadoAvaliacaoService.filtro.sort += ',desc';
			}
			if (event.sortOrder === 1) {
				this.resultadoAvaliacaoService.filtro.sort += ',asc';
			}
		}
	}
}
